import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-comment-on-confirmation',
  templateUrl: './comment-on-confirmation.component.html',
  styleUrls: ['./comment-on-confirmation.component.scss'],

})
export class CommentOnConfirmationComponent implements OnInit {
  @Input() entity: any;

  constructor() { }

  ngOnInit(): void {}

}
